import { useState } from 'react';

import { ExternalApplicationLinks, Loading } from '@sandtech-hub-monorepo/ui-kit-site';

import { PageHero } from '../../components/PageHero';
import communityHero from '../../assets/gsa/community-hero.webp';
import { ReactComponent as CommunityConfetti } from '../../assets/gsa/frontier-confetti-2.svg';

export const CommunityPage = () => {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  return (
    <>
      <PageHero
        backgroundImage={communityHero}
        showDecorations
        decoration={
          <CommunityConfetti
            aria-hidden
            className="pointer-events-none absolute right-0 top-0 hidden h-full w-auto sm:block"
          />
        }
      >
        <p className="text-2xl font-medium text-saffron">Your FIT Community</p>
        <h1 className="mt-3 text-4xl font-semibold md:text-5xl">
          The Frontier Network
        </h1>
        <p className="mt-3 max-w-3xl text-lg text-white">
          Where connections become collaborations, partnerships, and
          opportunities.
        </p>
      </PageHero>
      <div className="bg-background-tertiary">
        <div className="flex justify-between">
          {!isIframeLoaded && <Loading />}
          <iframe
            className={`block overflow-hidden border-0 ${
              !isIframeLoaded && 'hidden'
            }`}
            id="community-iframe"
            aria-label="community-iframe"
            title="FIT Community"
            width="100%"
            src={ExternalApplicationLinks.community}
            style={{ minHeight: 'calc(90dvh)' }}
            onLoad={() => setIsIframeLoaded(true)}
          />
        </div>
      </div>
    </>
  );
};
